import { render, staticRenderFns } from "./TableFree.vue?vue&type=template&id=c3be151e"
import script from "./TableFree.vue?vue&type=script&lang=js"
export * from "./TableFree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports